import type * as admin from '../admin'
import * as common from '../common'

/**
 * A mood that is expressed in fewer than this many characters is unlikely to
 * pose a risk for prompt injection
 */
const SAFE_MOOD_LENGTH_TO_AVOID_PROMPT_INJECTION = 20

export interface CheckIn {
  title: string
  prompt: string
  suggestedResponses: readonly string[]
}
export namespace CheckIn {
  export interface Response extends Response.Content {
    from: admin.User.ShareableInfo
  }
  export namespace Response {
    export interface Content extends Partial<Pick<CheckIn, 'prompt'>> {
      mood?: string
      response: string
      submittedOn: common.DateWithUtcOffset
    }
    export namespace Content {
      /**
       * Represents a {@link CheckIn.Response.Content} in a way that works well
       * for LLMs
       */
      export function representForLlm(
        response: Content,
        {
          comment,
        }: {
          readonly comment?: string
        } = {},
      ): string {
        let result = `${common.DateWithUtcOffset.format(response.submittedOn, 'eee MMM d y H:mm')}\n`
        // NOTE: `JSON.stringify` is meant to help reduce the chance of prompt
        // injection
        if (response.mood) {
          result += `${response.mood.length < SAFE_MOOD_LENGTH_TO_AVOID_PROMPT_INJECTION ? response.mood : JSON.stringify(response.mood)}\n`
        }
        if (response.prompt) {
          result += `Q: ${JSON.stringify(response.prompt)}${comment ? ` -- ${comment}` : ''}\nA: ${JSON.stringify(response.response)}`
        } else {
          result += JSON.stringify(response.response)
        }
        return result
      }
    }
  }
}
